import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// TODO find a way to load leaflet from cdn and run markercluster plugin after initializon of L
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';

export default function LeafletFactory() {
  L.Icon.Default.imagePath = '/media/leaflet/';
  return L;
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/components/pleaflet/leaflet.factory.js